import {useTheme} from "@mui/material/styles";
import {FormControl, InputLabel, MenuItem, Select} from "@mui/material";
import React from "react";

export function Form_MultiSelect(props) {
    const {item, localFormState, setLocalFormState} = props;
    const { inputSize = "normal" } = item;

    const theme = useTheme();
    const ITEM_HEIGHT = inputSize === "normal" ? 48 : 35;

    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: 250,
            },
        },
    };
    function getStyles(name, personName, theme) {
        return {
            fontWeight:
                personName.indexOf(name) === -1
                    ? theme.typography.fontWeightRegular
                    : theme.typography.fontWeightMedium,
        };
    }

    // const [selectedList, setSelectedList] = React.useState([]);

    const handleChange = (event) => {
        const {
            target: { value },
        } = event;
        setLocalFormState({
            ...localFormState,
            [item.key]: typeof value === 'string' ? value.split(',') : value
        });
    };
    // input={<OutlinedInput label="Name" />}value={selectedList}
    return (<>
        <FormControl fullWidth size={inputSize} variant="standard" sx={{ m: 0, minWidth: 120 }}>
            <InputLabel id="demo-multiple-name-label">{item.label}</InputLabel>
            <Select
                labelId="demo-multiple-name-label"
                id="demo-multiple-name"
                multiple
                variant="outlined"
                size={inputSize}
                helperText={item.helperText}
                label={item.label}
                value={(localFormState[item.key] === null || localFormState[item.key] === undefined) ? [] : localFormState[item.key]}
                onChange={handleChange}

                MenuProps={MenuProps}
            >
                {item.options !== undefined && item.options.map((i) => {
                    return (
                        <MenuItem key={i.value} value={i.value} style={getStyles(i.value, (localFormState[item.key] === null || localFormState[item.key] === undefined) ? [] : localFormState[item.key], theme)}>{i.label}</MenuItem>
                    );
                })}
            </Select>
        </FormControl>
    </>);
}